
export enum Glasses {
  Single= 'Single',
  Double= 'Double',

}